import config from './config';
import schema from './schema';

export default {
    config,
    schema
};
